import { IMenuGroup } from './menu-group.interface';
import { IMenuOption } from './menu-option.interface';

export class MenuGroup implements IMenuGroup {

    constructor(public label: string,
                public options: IMenuOption[]) {
    }
}
